module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_2.7fb0030e.png";